import { X, XCircle } from '@phosphor-icons/react';
import { Inline, Stack } from '@reelplicate/ui';

type AuthToastProps = {
  title: string;
  description: string;
  onDismiss: () => void;
};

/**
 * The error Toast variant the sign-in error screen uses (Figma Toast 77:63,
 * "Toast / Sign-in error"): Forest Ink surface, radius/lg, Shadow/LG, a
 * status/danger/on-inverse icon, title, description and close. Built here
 * because the library's Toast page isn't implemented yet - swap in the
 * library component when it ships. Errors persist until closed.
 */
export function AuthToast({ title, description, onDismiss }: AuthToastProps) {
  return (
    <Inline
      role="alert"
      data-auth-toast
      gap={3}
      alignY="top"
      className="bg-bg-inverse text-text-inverse shadow-lg fixed top-6 left-1/2 z-10 w-[380px] max-w-[calc(100vw-32px)] -translate-x-1/2 rounded-lg py-3 pr-3 pl-4"
    >
      <XCircle aria-hidden className="text-status-danger-on-inverse size-5 shrink-0" />
      <Stack gap={0.5} className="min-w-0 flex-1">
        <p className="text-label-md">{title}</p>
        <p className="text-body-sm opacity-78">{description}</p>
      </Stack>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={onDismiss}
        className="text-icon-inverse focus-visible:shadow-focus-ring flex shrink-0 cursor-pointer rounded-xs outline-none"
      >
        <X aria-hidden className="size-4" />
      </button>
    </Inline>
  );
}
